import theme from "styles/theme-main"
import styled from "styled-components"

export const Row = styled.div`
  padding-bottom: 40px;
`

export const TextWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  color: ${theme.colors.primary};
`
